module.exports = __webpack_public_path__ + "static/auswaertiges-amt-logo-7d21f48ca74f26e197d7014f4a1054f9.svg";